var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-screen w-full overflow-hidden"},[_c('TheHeader'),_vm._v(" "),_c('nuxt',{staticClass:"h-screen-min-header"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }